import { ClassBookerModel } from './ClassBookerModel';
import { MemberModel } from './MemberModel';

export class ClassMemberModel extends ClassBookerModel {
    constructor(memberData) {
        super(memberData);

        const memberships = this.getMemberships(memberData);

        this._member = {
            ...this.booker,
            memberships,
        };
    }

    get member() {
        return this._member;
    }

    getMemberships(memberData) {
        let memberships = [];

        if (memberData.memberships && memberData.memberships.data) {
            memberships = memberData.memberships.data.map(membership => {
                const memberModel = new MemberModel(membership);
                return { ...memberModel.member };
            });
        }

        return memberships;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/ClassMemberModel.js